import React from 'react';
import { colors } from '@styleseat/brand';
import { Inline, Box } from '@styleseat/ui';
import {
  Stack,
  Button,
  Separator,
  BodyText,
} from '../../../../ui';
import { BasicCircleXIcon } from '../../../../ui/Icons';

import type { ProAppointment } from '../../../../../api/Providers/Appointments';

type ButtonsProps = {
  inCancellationWindow: boolean;
  proCanCancel: boolean;
  appointment: ProAppointment;
  onKeepAppointmentClick: () => void;
  onSmsClick: () => void;
  onCancelAppointmentClick: () => void;
};

const Buttons: React.FC<ButtonsProps> = ({
  inCancellationWindow,
  proCanCancel,
  appointment,
  onKeepAppointmentClick,
  onSmsClick,
  onCancelAppointmentClick,
}) => (
  <Stack
    space={24}
    paddingBottom={24}
  >
    <Separator
      appearance="extrathin"
      color={colors.lightGrey}
      paddingY={0}
    />
    <Stack
      space={16}
      paddingX={24}
    >
      <Button
        appearance="primary-neue"
        size="medium-wide"
        text="Keep Appointment"
        clickTracking={{
          name: 'Cancel Appointment Modal Keep Appointment Button Clicked',
          params: {
            appointment_id: appointment.id,
            provider_id: appointment.provider,
            client_id: appointment.client.id,
          },
        }}
        testID="cancel-appointment-modal-keep-appointment-button"
        onClick={onKeepAppointmentClick}
      />
      {inCancellationWindow && (
        <Button
          appearance="outline-thin"
          size="medium-wide"
          text="Ask Client To Cancel Via SMS"
          clickTracking={{
            name: 'Cancel Appointment Modal Ask Client To Cancel Button Clicked',
            params: {
              appointment_id: appointment.id,
              provider_id: appointment.provider,
              client_id: appointment.client.id,
            },
          }}
          testID="cancel-appointment-modal-ask-client-button"
          onClick={onSmsClick}
        />
      )}
      {(proCanCancel || (!inCancellationWindow && !proCanCancel)) && (
        <Button
          disabled={!proCanCancel}
          appearance="outline-thin"
          size="medium-wide"
          style={{
            borderColor: proCanCancel ? colors.red : colors.silver,
            color: proCanCancel ? colors.red : colors.silver,
          }}
          clickTracking={{
            name: 'Cancel Appointment Modal Cancel Appointment Button Clicked',
            params: {
              appointment_id: appointment.id,
              provider_id: appointment.provider,
              client_id: appointment.client.id,
            },
          }}
          testID="cancel-appointment-modal-cancel-appointment-button"
          onClick={onCancelAppointmentClick}
        >
          <Inline
            space={8}
            paddingX={24}
            paddingY={10}
            justifyContent="center"
          >
            <Box
              paddingTop={2}
            >
              <BasicCircleXIcon
                height={14}
                width={14}
                color={proCanCancel ? colors.red : colors.silver}
              />
            </Box>
            <BodyText
              color={proCanCancel ? colors.red : colors.silver}
              weight="bold"
              appearance="medium"
            >
              Cancel Appointment
            </BodyText>
          </Inline>
        </Button>
      )}
    </Stack>
  </Stack>
);

export default Buttons;
